import { Node } from '@cast/types';

import { CopyToClipboard } from 'components/clickable-actions';
import { notReachable } from 'utils/types/not-reachable';

import { LinkBehaviour, Typography, Stack } from '@cast/design-system';

type Props = {
  node: Node;
  clickable?: boolean;
  onNameClick: () => void;
  copyToClipboardField: 'name' | 'id';
};

const getCopyToClipboardText = ({
  copyToClipboardField,
  node,
}: Pick<Props, 'copyToClipboardField' | 'node'>): string => {
  switch (copyToClipboardField) {
    case 'name':
      return node.name;
    case 'id':
      return node.id;
    default:
      return notReachable(copyToClipboardField);
  }
};

export const NodeNameCell = ({
  node,
  clickable,
  onNameClick,
  copyToClipboardField,
}: Props) => {
  const { name } = node;
  const copyToClipboardText = getCopyToClipboardText({
    copyToClipboardField,
    node,
  });

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      sx={{
        overflow: 'hidden',
      }}
    >
      {copyToClipboardText && (
        <CopyToClipboard
          text={copyToClipboardText}
          iconSize="16px"
          strokeWidth={1.5}
        />
      )}

      {clickable ? (
        <LinkBehaviour
          testId="node-name-link"
          variant="P12M"
          noWrap
          onClick={(e) => {
            e.stopPropagation();
            onNameClick();
          }}
        >
          {name || '-'}
        </LinkBehaviour>
      ) : (
        <Typography variant="inherit" noWrap>
          {name || '-'}
        </Typography>
      )}
    </Stack>
  );
};
